import { createContext } from "react";

/** ========== */

const context = createContext({
  multipleOpen: false,
});

export default context;

/** ========== */
